module.exports = "pegasus_template/assets/hexagon-pinterest.png";